import React from "react";
import Modal from "../../../shared/components/ui/Modal";

const BuyConfirmModal = ({ show, number, onCancel, onConfirm, processing = false }) => {
  return (
    <Modal
      show={show}
      onClose={onCancel}
      header={
        <h2 className="text-lg font-bold">Confirm Purchase</h2>
      }
      description={
        <p className="text-sm text-muted">
          Are you sure you want to purchase this number?
        </p>
      }
      footer={
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={processing}
            className="px-5 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(number)}
            disabled={processing}
            className="px-5 py-2 bg-primary text-white rounded-lg text-sm font-bold tracking-wider hover:bg-primary/90 transition-colors"
          >
            {processing ? "Processing..." : "Confirm"}
          </button>
        </div>
      }
    >
      {number && (
        <div className="bg-light rounded-xl p-4 space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted">Number</span>
            <span className="font-semibold text-primary">{number.number || "-"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted">Type</span>
            <span className="text-content">{number.type || "-"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted">Monthly Fee</span>
            <span className="font-semibold text-primary">
              {number.monthlyFee || "-"}
            </span>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default BuyConfirmModal;
